import RLib from "./RLib"
import { Translate as t } from "../../config/Translate"

const RayFormValidation = (formControls, inputs) => {
    const errs = [];
    formControls.map(x => x.items.map(y => {
        if (y.name.indexOf(".") > -1) {
            const arr = y.name.split(".");
            const child = inputs[arr[0]];
            if (y.required && child[arr[1]] == "") {
                errs.push({ name: y.name, msg: y.label + " is required" });
            } else {

            }
        } else {
            // console.log(inputs[y.name] + " - " + y.required);

            if ((inputs[y.name] == "" || inputs[y.name] == undefined)) {
                if (y.required)
                    errs.push({ name: y.name, msg: y.label + " is required" });
            } else {
                y.val = inputs[y.name];
                const errCheckResult = CheckValidateValue(y);
                if (errCheckResult)
                    errs.push(errCheckResult);
            }
        }
    }));
    return errs;
}
const CheckValidateValue = (obj) => {
    let err = null;
    if (obj.val == "") {
        if (obj.required == true) {
            err = { name: obj.name, msg: obj.label + " is required" };
            return err;
        }
        return null;
    }
    switch (obj.type) {
        case "email":
            if (!RLib.ValidateEmail(obj.val))
                err = { name: obj.name, msg: "Please enter a valid email address" };
            break;
        case "tel":
            if (!RLib.ValidateTel(obj.val))
                err = { name: obj.name, msg: "Please enter a valid " + obj.label };
            break;
        case "password":
            // skipStrength: 항목 단위 옵션(기본 false) — 기존 비밀번호를 입력받는 칸은 필수 여부만 본다.
            if (!obj.skipStrength && !RLib.ValidatePasswordStrength(obj.val))
                err = { name: obj.name, msg: t('auth.message.passwordCreateComment') };
            break;
    }
    return err;
}
export default RayFormValidation;
export { CheckValidateValue }